<template>
  <div class="personageBox">
    <div class="personageMain">
      <breadcrumb>
        <el-breadcrumb slot="breadcrumb" separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>个人中心</el-breadcrumb-item>
        </el-breadcrumb>
      </breadcrumb>
      <div class="accountCon">
        <div class="accountContop ft14">
          <p class="accountConHead">基本信息</p>
          <div class="auntContent" v-show='realNameg'>
            <ul>
              <li style="width:108px;">姓名：</li>
              <li style="text-align:left;display:flex;align-items:center;" class="realName user_name_title">
                {{ result.realName ? result.realName : '' }}{{ result.realName ? '/' : '' }}{{ result.mobile ? result.mobile : result.mail }}
              </li>
              <li>
                <span style="color: #28BF15;" v-if="result.authenticationStatus=='2'" class="successful"><img
                    src='../../../assets/images/userHome/realname_icon.png'></span>
                <span style="color: #E1BC14;" v-if="result.authenticationStatus=='1'"><img
                    src='../../../assets/images/userHome/auditing_icon.png'></span>
                <span style="color: #E88078;" v-if="result.authenticationStatus=='3'"><img
                    src='../../../assets/images/userHome/certificationfarl_icon.png'></span>
                <span style="color: #E88078;" v-if="result.authenticationStatus=='5'"><img
                    src='../../../assets/images/userHome/certificationfarl_icon.png'></span>
                <span style="color: #E88078;" v-if="result.authenticationStatus=='0'"><img
                    src='../../../assets/images/userHome/unnamed_icon.png'></span>
              </li>
              <li>
                <router-link tag="span" to="PersonalCertificate"
                             v-if="result.authenticationStatus=='3' || result.authenticationStatus=='5' ||result.authenticationStatus=='0'">
                  {{ result.authenticationStatus == 0 ? '立即认证' : '重新认证' }}
                </router-link>
              </li>
            </ul>
            <ul>
              <li style="width:108px;">身份证号：</li>
              <li style="text-align:left;">{{ result.idcardNumber }}</li>
            </ul>
            <div class="create_enterprise" v-if="!getUserInfo.enterpriseList.length">
              <div @click="goAttestationFn(1)">
                <i class="create_icon"></i>
                <span>创建企业</span>
              </div>
            </div>
          </div>
          <div class="auntContentq" v-show='realNameq'>
            <ul>
              <li>机构名称：</li>
              <li style="text-align:left;display:flex;align-items:center;" class="realName user_name_title">
                {{ result.realName }}
              </li>
              <li>
                <span style="color: #28BF15;" v-if="result.authenticationStatus=='2'" class="successful"><img
                    src='../../../assets/images/userHome/realname_icon.png'></span>
                <span style="color: #E1BC14;" v-if="result.authenticationStatus=='1'"><img
                    src='../../../assets/images/userHome/auditing_icon.png'></span>
                <span style="color: #E88078;" v-if="result.authenticationStatus=='3'"><img
                    src='../../../assets/images/userHome/certificationfarl_icon.png'></span>
                <span style="color: #E88078;" v-if="result.authenticationStatus=='5'"><img
                    src='../../../assets/images/userHome/certificationfarl_icon.png'></span>
                <span style="color: #E88078;" v-if="result.authenticationStatus=='0'"><img
                    src='../../../assets/images/userHome/unnamed_icon.png'></span>
              </li>
              <li>
                <router-link tag="span" to="enterprise"
                             v-if="result.authenticationStatus=='3' || result.authenticationStatus=='0' || result.authenticationStatus=='5'">
                  {{ result.authenticationStatus == 0 ? '立即认证' : '重新认证' }}
                </router-link>
              </li>
            </ul>
            <ul>
              <li>所属行业：</li>
              <li>{{ result.industryName }}</li>
            </ul>
            <ul>
              <li>机构类型：</li>
              <li>{{ result.categoryName }}</li>
            </ul>
            <ul>
              <li>联系地址：</li>
              <li>
                {{ result.provinceName ? result.provinceName + result.cityName + result.areaName + result.enterpriseAddress : "" }}
              </li>
            </ul>
            <ul>
              <li>固定电话：</li>
              <li>{{ result.enterprisePhone }}</li>
            </ul>
          </div>
          <div class="auntContents" v-show="allNot">
            <!-- <p class="ft16">您还未进行实名认证，认证后才可签署！</p> -->
            <p>
              <span class="Personal_user" @click="goAttestationFn(0)"></span>
              <span v-show="EnSign" class="enterprise_user" @click="goAttestationFn(1)"></span>
            </p>
          </div>
        </div>
        <div class="accountContbottom ft14">
          <p class="accountConHead">安全设置</p>
          <ul class="safetyCon">
            <li class="safetyItem">
              <div class="safetyName fl">
                登录密码
              </div>
              <div class="satetyTips fl">
                <span v-show="saftList.existLoginPwd==1"></span>
                <span v-show="saftList.existLoginPwd==0">********</span>
              </div>
              <div class="satetySet fr">
                <ul v-show="saftList.existLoginPwd==1">
                  <li class="notSetItem"><span>未设置</span></li>
                  <li class="lineSet"></li>
                  <li class="notSetItem notSetItems">
                    <router-link to="safety/setLoginPwd" tag="span">设置</router-link>
                  </li>
                </ul>
                <ul v-show="saftList.existLoginPwd==0">
                  <li class="setItem"><span>已设置</span></li>
                  <li class="lineSet"></li>
                  <li class="notSetItem notSetItems">
                    <router-link to="safety/amendLoginpwd" tag="span">修改</router-link>
                  </li>
                </ul>
              </div>
            </li>
            <li class="safetyItem">
              <div class="safetyName fl">
                签约密码
              </div>
              <div class="satetyTips fl">
                <span v-show="saftList.existSginPwd==1"></span>
                <span v-show="saftList.existSginPwd==0">********</span>
              </div>
              <div class="satetySet fr">
                <ul v-if="saftList.existSginPwd==1">
                  <li class="notSetItem"><span>未设置</span></li>
                  <li class="lineSet"></li>
                  <li class="notSetItem notSetItems">
                    <router-link to="safety/setSignPwd" tag="span">设置</router-link>
                  </li>
                </ul>
                <ul v-if="saftList.existSginPwd==0">
                  <li class="setItem"><span>已设置</span></li>
                  <li class="lineSet"></li>
                  <li class="notSetItem notSetItems">
                    <router-link to="safety/amendSignPwd" tag="span">修改</router-link>
                  </li>
                </ul>
              </div>
            </li>
            <li class="safetyItem">
              <div class="safetyName fl">
                绑定手机号
              </div>
              <div class="satetyTips fl">
                {{ saftList.mobile }}
              </div>
              <div class="satetySet fr">
                <ul v-if="saftList.mobile==''">
                  <li class="notSetItem"><span>未绑定</span></li>
                  <li class="lineSet"></li>
                  <li class="notSetItem notSetItems"><span @click="handelClick()">绑定</span></li>
                </ul>
                <ul v-if="saftList.mobile!=''">
                  <li class="setItem"><span>已绑定</span></li>
                  <li class="lineSet"></li>
                  <li class="SetItem"><span @click="handelClicks()">修改</span></li>
                </ul>
              </div>
            </li>
            <li class="safetyItem">
              <div class="safetyName fl">
                绑定邮箱
              </div>
              <div class="satetyTips fl">
                {{ saftList.mail }}
              </div>
              <div class="satetySet fr">
                <ul v-if="saftList.mail==''">
                  <li class="notSetItem"><span>未绑定</span></li>
                  <li class="lineSet"></li>
                  <li class="notSetItem notSetItems"><span @click="eMailFn">绑定</span></li>
                </ul>
                <ul v-if="saftList.mail!=''">
                  <li class="setItem"><span>已绑定</span></li>
                  <li class="lineSet"></li>
                  <li class="SetItem"><span @click="eMailFns">修改</span></li>
                </ul>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <Dialog :visible="dialogVisiblePhtot" :dialogTitle="'绑定手机号'" v-on:closeDialog="closeDialog" :width="'450px'">
      <div slot="dialog" class="sheHints">
        <setphoto :message="saftList" @closeDialog="closeDialog" @init="init"></setphoto>
      </div>
    </Dialog>
    <Dialog :visible="dialogVisiblePhtot1" :dialogTitle="'更换绑定手机号'" v-on:closeDialog="closeDialog" :width="'450px'">
      <div slot="dialog" class="sheHint">
        <p class="hint">当前手机号：{{ saftList.mobile }}</p>
        <setphoto :message="saftList" @closeDialog="closeDialog" @init="init"></setphoto>
      </div>
    </Dialog>
    <Dialog :visible="dialogVisibleEmail" :dialogTitle="'绑定邮箱'" v-on:closeDialog="closeDialog" :width="'450px'">
      <div slot="dialog" class="sheHints">
        <setemail :message="saftList" @closeDialog="closeDialog" @init="setEmailCallback"></setemail>
      </div>
    </Dialog>
    <Dialog :visible="dialogVisibleEmail1" :dialogTitle="'更换绑定邮箱'" v-on:closeDialog="closeDialog" :width="'450px'">
      <div slot="dialog" class="sheHint">
        <p class="hint">当前邮箱：{{ saftList.mail }}</p>
        <setemail :message="saftList" @closeDialog="closeDialog" @init="init"></setemail>
      </div>
    </Dialog>
    <Dialog :visible="supplementFlag" :showClose="false" :dialogTitle="'消息提示'" @closeDialog="closeDialog"
            :width="'450px'">
      <div slot="dialog" class="supplement-con">
        <p>{{ supplementMsg }}</p>
        <button @click="nextTosupplement">下一步</button>
      </div>
    </Dialog>
    <Dialog :visible="supplementFlagType" :showClose="false" :dialogTitle="'消息提示'" @closeDialog="closeDialog"
            :width="'450px'">
      <div slot="dialog" class="supplement-con">
        <span>当前实名主体为：</span>
        <el-radio-group v-model="supplementFlagValue">
          <el-radio-button label="1" class="ContractType-radio">法人代表人</el-radio-button>
          <el-radio-button label="2" class="ContractType-radio">受托人</el-radio-button>
        </el-radio-group>
        <button @click="nextTosupplementType">下一步</button>
      </div>
    </Dialog>
  </div>
</template>

<script>
import BaseApi from "@lib/baseApi.js";
import breadcrumb from "@common/Breadcrumb.vue";
import setphoto from "./components/safety/Setphoto.vue";
import setemail from "./components/safety/Setemail.vue";
import Dialog from "../../common/Dialog.vue";
import {mapState, mapGetters} from "vuex";

export default {
  data() {
    return {
      allNot: false,
      resultData: {},
      result: {},
      saftList: {},
      realNameg: false,
      realNameq: false,
      step: 0,
      dialogVisiblePhtot: false,//手机号
      dialogVisiblePhtot1: false,
      succeefulBox: true,
      dialogVisibleEmail: false,//邮箱
      dialogVisibleEmail1: false,
      safetyCon: true,
      // revisionBox:true,
      aignBox: true,
      signPwdBox: false,
      EnSign: true,
      supplementFlag: false,//补充弹框
      supplementMsg: "平台账户体系升级，部分功能使用受限，为保障使用体验，您需补充部分机构信息。",
      supplementFlagType: false,
      supplementFlagValue: "1"
    };
  },
  computed: {
    ...mapState(['currentInfo', 'userInfo']),
    ...mapGetters(['getUserInfo'])
  },
  mounted() {
    const routeParams = this.$route.params;
    if (routeParams.signPage) {
      // 如果是签约时提示绑定邮箱
      this.dialogVisibleEmail = true;
    }
    this.statusFn();
    this.init();
    if (this.getUserInfo.hasOwnProperty("currentUserId")) {
      if (this.getUserInfo.enterpriseList.length) {
        if (this.getUserInfo.enterpriseList[0].authenticationStatus == 2) {
          this.EnSign = false;
        } else {
          this.EnSign = true;
        }
      } else {
        this.EnSign = true;
      }
    } else {
      this.EnSign = true;
    }
  },
  methods: {
    init() {
      BaseApi.createRpcToken("/user/getSecurityInfo").then((data) => {
        this.saftList = data.datas.info
      }, (data) => {
      }).catch(function (e) {
        errorLog(e);
      })
    },
    statusFn() {
      BaseApi.createRpcToken("/user/v2/getUserInfo").then(
          (data) => {
            // if(this.getUserInfo.currentUserId==data.datas.person.userId){
            //   this.result=data.datas.person;
            // }else{
            //   this.result=data.datas.enterpriseList[0];
            // }
            let userArr = [...[data.datas.person], ...data.datas.enterpriseList];
            let curInfo = userArr.filter(item => item.userId == data.datas.currentUserId);
            this.result = curInfo[0]
            this.resultData = data.datas
            this.step = this.result.authenticationStatus;
            if (this.result.authenticationStatus == 2 ||
                this.result.authenticationStatus == 1 ||
                this.result.authenticationStatus == 3 ||
                this.result.authenticationStatus == 5
            ) {
              this.allNot = false;
              if (this.result.realNameType == '1') {
                this.realNameg = true;
                this.realNameq = false;
              } else {
                this.realNameg = false;
                this.realNameq = true;
                if (this.result.authenticationStatus == 2 && (this.result.legalPersonStatus == 0 || this.result.legalPersonStatus == 1 || this.result.legalPersonStatus == 3 || this.result.legalPersonStatus == 5)) {
                  this.supplementFlag = true;
                }
              }
            } else {
              this.allNot = true;
              this.realNameg = false;
              this.realNameq = false;
            }
          },
          () => {

          }
      );
    },
    //补充信息下一步
    nextTosupplement() {
      this.supplementFlag = false;
      this.supplementFlagType = true;
    },
    nextTosupplementType() {
      this.$router.push({
        path: '/personal/users/enterpriseSupplement',
        query: {
          step: this.step,
          flag: 2,
          exId: '',
          supplementFlagValue: this.supplementFlagValue
        },
      })
    },
    goAttestationFn(num) {
      if (num == 0) {
        this.$router.push({
          path: 'PersonalCertificate',
          query: {
            step: this.step,
          },
        })
      } else {
        this.$router.push({
          path: 'enterprise',
          query: {
            step: this.step,
            exId: this.userInfo.enterpriseList.length ? this.userInfo.enterpriseList[0].userId : ''
          },
        })
      }
    },
    closeDialog(data) {
      this.supplementFlag = data;
      this.dialogVisiblePhtot = data;
      this.dialogVisibleEmail = data;
      this.dialogVisiblePhtot1 = data;
      this.dialogVisibleEmail1 = data;
      this.supplementFlag = false;
      this.succeefulBox = true;
      this.supplementFlagType = false;
    },
    handelClick() {
      this.dialogVisiblePhtot = true;
    },
    handelClicks() {
      this.dialogVisiblePhtot1 = true;
    },
    eMailFn() {
      this.dialogVisibleEmail = true;
    },
    eMailFns() {
      this.dialogVisibleEmail1 = true;
    },
    cancelFn(num) {
      if (num == 0) {
        this.dialogVisiblePhtot = false;
      } else {
        this.dialogVisibleEmail = false;
      }
    },
    truePhoto() {
      this.succeefulBox = false;
    },
    candelSetFn() {
      this.safetyCon = true;
      this.setLoginPwd = false;
      this.signPwdBox = false;
    },
    truePwdFn() {
      if (this.oldPwd == '' || this.newPwd == '' || this.truePwd == '') {
        return;
      }
      // this.revisionBox=false;
      this.aignBox = false;
    },
    // 设置邮箱回调
    setEmailCallback() {
      if (this.$route.params.signPage) {
        // 如果是签约时提示绑定邮箱则回跳
        this.$router.push({
          name:'signIndex',
        })
      } else {
        // 初始化
        this.init();
      }
    }
  },
  components: {
    breadcrumb,
    setphoto,
    setemail,
    Dialog
  },
  watch: {
    "currentInfo"(data) {
      this.statusFn()
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.personageBox {
  background: #EAEDF1;
  width: 100%;
  box-sizing: border-box;

  .personageMain {
    width: 100%;
    height: 100%;
    background: #fff;
    border-radius: 3px;
    padding: 20px;
    box-sizing: border-box;
    overflow-y: scroll;

    .accountCon {
      width: 100%;
      display: table;
      margin-top: 10px;

      .accountContop {
        width: 100%;
        border: 1px solid #E4E8EB;

        .auntContent {
          width: 100%;
          display: flex;
          padding: 45px 20px;
          align-items: center;
          flex-direction: column;
          box-sizing: border-box;
          text-align: center;

          p {
            color: #E88078;
            margin-bottom: 30px;

            span {
              display: inline-block;
              width: 100px;
              height: 30px;
              // line-height: 30px;
              text-align: center;
              // border: 1px solid #E88078;
              border-radius: 3px;
              margin-right: 20px;
              cursor: pointer;
            }

            // span:hover{
            //   background-color: #A5303D;
            //   color:#fff;
            // }
          }

          .create_enterprise {
            width: 100%;

            div {
              width: 220px;
              height: 80px;
              background: rgba(255, 255, 255, 1);
              border: 1px solid rgba(206, 206, 206, 1);
              text-align: center;
              display: flex;
              align-items: center;
              flex-direction: column;
              justify-content: center;
              margin-top: 20px;
              cursor: pointer;

              .create_icon {
                width: 20px;
                height: 20px;
                background: url("~@image/userHome/create_nor_icon.png")
              }

              span {
                padding-top: 6px;
                color: #969696;
              }
            }

            div:hover .create_icon {
              background: url("~@image/userHome/create_hov_pre_icon.png")
            }
          }
        }

        .auntContentq {
          width: 100%;
          padding: 45px 20px;
          display: flex;
          align-items: center;
          flex-direction: column;
          box-sizing: border-box;
          text-align: center;

          span {
            display: inline-block;
            width: 100px;
            height: 30px;
            // line-height: 30px;
            text-align: center;
            // border: 1px solid #E88078;
            border-radius: 3px;
            margin-right: -10px;
            cursor: pointer;
          }

          ul {
            margin: 0 !important;
            line-height: 26px;

            li:nth-child(1) {
              color: #505050;
              display: flex;
              align-items: center;

              img {
                margin-right: 8px;
              }
            }

            li:nth-child(2) {
              text-align: left;
              padding-left: 20px;
              width: auto !important;
            }

            li:nth-child(3) {
              img {
                margin-top: 3px;
              }
            }

            li:nth-child(4) {
              span {
                margin-top: 3px;
                display: inline-block;
              }
            }
          }
        }

        .auntContents {
          width: 100%;
          padding: 45px 79px;
          display: flex;
          align-items: center;
          flex-direction: column;
          box-sizing: border-box;
          text-align: center;

          p:nth-child(1) {
            margin-bottom: 20px;
          }

          p {
            display: inline-block;
            color: #E88078;

            span {
              display: inline-block;
              width: 299px;
              height: 128px;
              margin-right: 20px;
              cursor: pointer;
            }

            .Personal_user {
              background: url("~@image/userHome/personalrealname_nor_img.png");
            }

            .enterprise_user {
              background: url("~@image/userHome/enterpriserealname_nor_img.png");
            }

            .Personal_user:hover {
              background: url("~@image/userHome/personalrealname_hov_pre_img.png");
            }

            .enterprise_user:hover {
              background: url("~@image/userHome/enterpriserealname_hov_pre_img.png");
            }
          }
        }

        .accountConHead {
          width: 100%;
          background: #F5F5F5;
          border-bottom: 1px solid #E4E8EB;
          height: 32px;
          line-height: 32px;
          text-align: left;
          text-indent: 10px;
          font-family: 'PingFangSC-Medium';
          font-size: 14px;
          color: #646464;
        }

        .successful {
          display: flex;
          align-items: center;

          img {
            margin-right: 5px;
          }
        }

        ul {
          width: 100%;
          display: flex;

          li {
            display: flex;
            align-items: center;
            flex-shrink: 0;
          }

          li:nth-child(1) {
            // height: 35px;;
            color: #505050;
            display: flex;
            align-items: center;
            flex-shrink: 0;

            img {
              width: 11px;
              margin-right: 8px;
            }
          }

          li:nth-child(2) {
            max-width: 904px;

            color: #7c7c7c;
          }

          li:nth-child(3) {
            margin: 0 20px;

            img {
              margin-top: 3px;
            }
          }

          li:nth-child(4) {
            cursor: pointer;

            span {
              display: inline-block;
              width: 60px;
              height: 20px;
              line-height: 20px;
              text-align: center;
              // border: 1px solid #969696;
              border-radius: 2px;
              font-size: 14px;
              color: #F5222D;
              margin-top: 3px;
            }

            span:hover {
              // background: #a5303d;
              // border-color: #a5303d;
              // border: 1px solid #a5303d;
              color: rgb(185, 34, 34);
            }
          }
        }

        ul:nth-child(1) {
          margin-bottom: 10px;
        }
      }

      .accountContbottom {
        width: 100%;
        border: 1px solid #E4E8EB;
        margin-top: 20px;

        .accountConHead {
          width: 100%;
          background: #F5F5F5;
          border-bottom: 1px solid #E4E8EB;
          height: 32px;
          line-height: 32px;
          text-align: left;
          text-indent: 10px;
          font-family: 'PingFangSC-Medium';
          font-size: 14px;
          color: #646464;
        }

        .safetyCon {
          width: 100%;
          display: block;
          padding: 0 20px;
          box-sizing: border-box;

          .safetyItem {
            display: block;
            width: 100%;
            height: 80px;
            padding: 32px 0;
            border-bottom: 1px solid #F2F2F2;
            box-sizing: border-box;

            .satetySet {
              color: #E88078;

              li {
                img {
                  width: 14px;
                  height: 14px;
                  vertical-align: middle;
                  margin-right: 6px;
                }
              }
            }

            .safetyName {
              width: 108px;
              color: #505050;
              font-family: 'PingFangSC-Medium';

              img {
                vertical-align: middle;
                margin-right: 7px;
              }
            }

            .satetyTips {
              color: #7c7c7c;
            }

            .satetySet {
              li {
                float: left;
              }

              .notSetItem {
                color: #7c7c7c;
                cursor: pointer;
              }

              .notSetItems {
                color: #E88078;
                cursor: pointer;
              }

              .setItem {
                color: #28BF15;
              }

              .SetItem {
                cursor: pointer;
              }

              .lineSet {
                width: 2px;
                height: 18px;
                background: #969696;
                margin: 0 20px;
              }
            }
          }

          .safetyItem:last-child {
            border: 0;
          }
        }
      }
    }
  }

  .succeefulBox {
    width: 100%;
    height: 240px;
    padding: 92px 0;
    box-sizing: border-box;
  }

  .sheHint {
    overflow: hidden;

    .hint {
      color: #646464;
      text-align: center;
      margin: 28px 0;
      font-size: 14px;
      height: 18px;
    }
  }

  .sheHints {
    padding-top: 49px;
  }

  // .user_name_title{
  //   overflow:hidden;
  //   white-space:nowrap;
  //   text-overflow:ellipsis;
  // }
}

.supplement-con {
  width: 100%;
  text-align: left;
  padding: 30px 24px;
  box-sizing: border-box;

  .el-radio-button__inner {
    margin-left: 14px;
    width: 100px;
    height: 36px;
    background: #FFFFFF !important;
    box-shadow: none;
    border-radius: 18px !important;
    border: 1px solid #D9D9D9 !important;
    outline: none;
    text-align: center !important;
    padding: 11px 0px !important;
  }

  .el-radio-button__inner:hover {
    color: #5B5B5B;
  }

  .el-radio-button__orig-radio:checked + .el-radio-button__inner {
    background: #FFF0F0;
    border-color: #D81212 !important;
    color: #D81212 !important;
    box-shadow: -1px 0 0 0 #fff;
  }

  button {
    display: block;
    width: 100px;
    height: 32px;
    background: #FFFFFF;
    border: 1px solid #D81212;
    text-align: center;
    color: #D81212;
    cursor: pointer;
    margin: 0 auto;
    margin-top: 20px;
  }
}
</style>
